"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardmarketArticle = void 0;
var CardmarketArticle = /** @class */ (function () {
    function CardmarketArticle(cardmarketArticle) {
        var _a;
        if (Array.isArray(cardmarketArticle)) {
            var attributes = cardmarketArticle;
            this.attributes = attributes;
        }
        else if (cardmarketArticle) {
            var priceGBP = (_a = cardmarketArticle.prices.find(function (p) { return p.currencyCode === 'GBP'; })) === null || _a === void 0 ? void 0 : _a.price;
            this.attributes = [
                cardmarketArticle.count,
                cardmarketArticle.condition,
                cardmarketArticle.language.idLanguage,
                cardmarketArticle.idProduct,
                [cardmarketArticle.price, priceGBP],
                cardmarketArticle.comments,
                cardmarketArticle.isFoil ? 1 : 0,
                cardmarketArticle.isPlayset ? 1 : 0,
                cardmarketArticle.isReverseHolo ? 1 : 0,
                cardmarketArticle.isSigned ? 1 : 0,
                cardmarketArticle.isFirstEd ? 1 : 0,
                cardmarketArticle.idArticle,
                [
                    cardmarketArticle.seller.isCommercial,
                    cardmarketArticle.seller.reputation,
                    cardmarketArticle.seller.sellCount,
                    cardmarketArticle.seller.username,
                    cardmarketArticle.seller.address.country,
                ],
                cardmarketArticle.isAltered ? 1 : 0,
            ];
        }
        else {
            throw new Error('data missing for construction of cardmarket article thing');
        }
    }
    Object.defineProperty(CardmarketArticle.prototype, "quantity", {
        get: function () {
            return this.attributes[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardmarketArticle.prototype, "condition", {
        get: function () {
            return this.attributes[1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardmarketArticle.prototype, "idLanguage", {
        get: function () {
            return this.attributes[2];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardmarketArticle.prototype, "idProduct", {
        get: function () {
            return this.attributes[3];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardmarketArticle.prototype, "price", {
        get: function () {
            return this.attributes[4][0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardmarketArticle.prototype, "priceGBP", {
        get: function () {
            return this.attributes[4][1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardmarketArticle.prototype, "comment", {
        get: function () {
            return this.attributes[5];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardmarketArticle.prototype, "isFoil", {
        get: function () {
            return this.attributes[6] === 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardmarketArticle.prototype, "isPlayset", {
        get: function () {
            return this.attributes[7] === 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardmarketArticle.prototype, "isReverseHolo", {
        get: function () {
            return this.attributes[8] === 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardmarketArticle.prototype, "isSigned", {
        get: function () {
            return this.attributes[9] === 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardmarketArticle.prototype, "isFirstEd", {
        get: function () {
            return this.attributes[10] === 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardmarketArticle.prototype, "idArticle", {
        get: function () {
            return this.attributes[11];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardmarketArticle.prototype, "isShiny", {
        get: function () {
            return this.isReverseHolo || this.isFoil;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardmarketArticle.prototype, "seller", {
        get: function () {
            return {
                isCommercial: this.attributes[12][0],
                reputation: this.attributes[12][1],
                sellCount: this.attributes[12][2],
                username: this.attributes[12][3],
                country: this.attributes[12][4],
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardmarketArticle.prototype, "isAltered", {
        get: function () {
            if (this.attributes.length < 14) {
                return false;
            }
            return this.attributes[13] === 1;
        },
        enumerable: false,
        configurable: true
    });
    CardmarketArticle.prototype.toPlainObject = function () {
        return {
            count: this.quantity,
            condition: this.condition,
            language: {
                idLanguage: this.idLanguage,
                languageName: '',
            },
            idProduct: this.idProduct,
            price: this.price,
            comments: this.comment,
            isFoil: this.isFoil,
            isPlayset: this.isPlayset,
            isReverseHolo: this.isReverseHolo,
            isSigned: this.isSigned,
            isFirstEd: this.isFirstEd,
            isAltered: this.isAltered,
            idArticle: this.idArticle,
            prices: [
                {
                    currencyCode: 'EUR',
                    idCurrency: 1,
                    price: this.price,
                },
                {
                    currencyCode: 'GBP',
                    idCurrency: 2,
                    price: this.priceGBP || this.price,
                },
            ],
            seller: {
                isCommercial: this.seller.isCommercial,
                reputation: this.seller.reputation,
                sellCount: this.seller.sellCount,
                username: this.seller.username,
                country: this.seller.country,
                address: {
                    country: this.seller.country,
                },
            },
        };
    };
    return CardmarketArticle;
}());
exports.CardmarketArticle = CardmarketArticle;
//# sourceMappingURL=CardmarketArticle.js.map